module.exports = __webpack_public_path__ + "img/texture-brick-1-top-birthday.ef0014c5.jpg";